import { useEffect, useState } from "react";
import Sidebar from "../components/layout/Sidebar";
import { authRequestNbGet } from "../utils/helpers";

const TravelersPage = () => {
    const [passengers, setPassengers] = useState([]);
    const [filters, setFilters] = useState({
        name: "",
        email: "",
        mobile: ""
    });
    const [page, setPage] = useState(1);
    const [limit] = useState(10);
    const [total, setTotal] = useState(0);
    const [totalPages, setTotalPages] = useState(0);
    const [loading, setLoading] = useState(false);

    const fetchTravelers = async (pageNo = 1) => {
        try {
            setLoading(true);

            const query = new URLSearchParams({
                page: pageNo,
                limit,
                name: filters.name || "",
                email: filters.email || "",
                mobile: filters.mobile || ""
            }).toString();

            const res = await authRequestNbGet(`me/get-travelers/all?${query}`);

            if(res?.status === 200 && res.data) {
                const items = res.data.items || res.data || [];
                const meta = res.data.meta || {};

                setPassengers(items);
                setTotal(meta.total || 0);
                setTotalPages(meta.totalPages || 0);
                setPage(parseInt(meta.page) || pageNo);
            } else {
                setPassengers([]);
                setTotal(0);
                setTotalPages(0);
            }
        } catch(e) {
            console.error("Error fetching travelers", e);
            setPassengers([]);
            setTotal(0);
            setTotalPages(0);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchTravelers(1);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setFilters((prev) => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSearchSubmit = (e) => {
        e.preventDefault();
        fetchTravelers(1);
    };

    const handleReset = () => {
        setFilters({
            name: "",
            email: "",
            mobile: ""
        });

        fetchTravelers(1);
    };

    const handlePageChange = (newPage) => {
        if(newPage < 1) return;
        if(totalPages && newPage > totalPages) return;

        fetchTravelers(newPage);
    };

    const renderTypeBadge = (type) => {
        if(!type) return "-";

        const t = type.toLowerCase();
        let className = "badge bg-secondary";

        if(t === "main") className = "badge bg-success";
        else if(t === "co-passenger") className = "badge bg-info text-dark";

        return <span className={className}>{type}</span>;
    };

    return (
        <>
            <div className="bgdashboard"></div>
            <Sidebar />

            <div className="dashboardMain sidebarPadding mainPanel">
                <div className="mainPanelIN">
                    <div className="relative">
                        <div className="row">
                            <div className="col-12 mt-0">
                                <section className="documentsBanner">
                                    <div className="documentsBannerIcon">
                                        <div className="documentIcon">
                                            <i className="fa-solid fa-users"></i>
                                        </div>
                                    </div>

                                    <div className="documentsBannerContent">
                                        <h3>Saved Passengers</h3>
                                        <p>Manage your saved passenger details for quick booking.</p>
                                    </div>

                                    <div className="documentsSkyline">
                                        <span className="skylineBuilding building1"></span>
                                        <span className="skylineBuilding building2"></span>
                                        <span className="skylineBuilding building3"></span>
                                        <span className="skylineBuilding building4"></span>

                                        <span className="skylineTower tower1"></span>
                                        <span className="skylineTower tower2"></span>
                                        <span className="skylineTower tower3"></span>

                                        <div className="travelBridge"></div>
                                        <i className="fa-solid fa-plane skylinePlane"></i>
                                    </div>
                                </section>
                            </div>

                            <div className="col-12 mb-3">
                                <div className="card shadow-sm">
                                    <div className="card-body">
                                        <form onSubmit={handleSearchSubmit}>
                                            <div className="row g-2">
                                                <div className="col-md-4">
                                                    <div className="searchField">
                                                        <div className="searchFieldIcon">
                                                            <i className="fa-solid fa-user"></i>
                                                        </div>

                                                        <div className="searchFieldContent">
                                                            <label>Name</label>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                placeholder="Search by name"
                                                                name="name"
                                                                value={filters.name}
                                                                onChange={handleInputChange}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="col-md-4">
                                                    <div className="searchField">
                                                        <div className="searchFieldIcon">
                                                            <i className="fa-solid fa-envelope"></i>
                                                        </div>

                                                        <div className="searchFieldContent">
                                                            <label>Email</label>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                placeholder="Search by email"
                                                                name="email"
                                                                value={filters.email}
                                                                onChange={handleInputChange}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="col-md-4">
                                                    <div className="searchField">
                                                        <div className="searchFieldIcon">
                                                            <i className="fa-solid fa-phone"></i>
                                                        </div>

                                                        <div className="searchFieldContent">
                                                            <label>Mobile</label>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                placeholder="Search by mobile"
                                                                name="mobile"
                                                                value={filters.mobile}
                                                                onChange={handleInputChange}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="searchActions">
                                                <button
                                                    type="submit"
                                                    className="searchBtn"
                                                    disabled={loading}
                                                >
                                                    <i className="fa-solid fa-magnifying-glass"></i>
                                                    {loading ? "Searching..." : "Search"}
                                                </button>

                                                <button
                                                    type="button"
                                                    className="resetBtn"
                                                    onClick={handleReset}
                                                    disabled={loading}
                                                >
                                                    <i className="fa-solid fa-rotate"></i>
                                                    Reset
                                                </button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>

                            <div className="col-12">
                                <div className="card shadow-sm">
                                    <div className="card-body">
                                        <div className="d-flex justify-content-between align-items-center mb-2 flex-wrap">
                                            <h5 className="mb-0">Passenger List</h5>

                                            <small className="text-muted">
                                                Total: {total} | Page {page}
                                                {totalPages ? ` / ${totalPages}` : ""}
                                            </small>
                                        </div>

                                        {loading ? (
                                            <p className="mb-0">Loading passengers...</p>
                                        ) : passengers.length === 0 ? (
                                            <div className="noTours w-100">
                                                <div className="noToursIcon">
                                                    <i className="fa-solid fa-users"></i>
                                                </div>

                                                <h4>No passengers found.</h4>
                                                <p>No passengers list are available at the moment.</p>
                                            </div>
                                        ) : (
                                            <div className="table-responsive">
                                                <table className="table table-striped align-middle">
                                                    <thead>
                                                        <tr>
                                                            <th>#</th>
                                                            <th>Name</th>
                                                            <th>Email</th>
                                                            <th>Mobile</th>
                                                            <th>Type</th>
                                                            <th>Created At</th>
                                                        </tr>
                                                    </thead>

                                                    <tbody>
                                                        {passengers.map((pax, idx) => (
                                                            <tr key={pax.id}>
                                                                <td>{(page - 1) * limit + idx + 1}</td>

                                                                <td>
                                                                    {pax.name ||
                                                                        `${pax.first_name || ""} ${pax.last_name || ""}`.trim() ||
                                                                        "-"}
                                                                </td>

                                                                <td>{pax.email || "-"}</td>
                                                                <td>{pax.mobile || "-"}</td>
                                                                <td>{renderTypeBadge(pax.type)}</td>

                                                                <td>
                                                                    {pax.created_at
                                                                        ? new Date(pax.created_at).toLocaleString()
                                                                        : "-"}
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div>
                                        )}

                                        {totalPages > 1 && (
                                            <div className="d-flex justify-content-between align-items-center mt-3">
                                                <button
                                                    className="btn btn-outline-secondary btn-sm"
                                                    onClick={() => handlePageChange(page - 1)}
                                                    disabled={page <= 1 || loading}
                                                >
                                                    &laquo; Previous
                                                </button>

                                                <span className="small text-muted">
                                                    Page {page} of {totalPages}
                                                </span>

                                                <button
                                                    className="btn btn-outline-secondary btn-sm"
                                                    onClick={() => handlePageChange(page + 1)}
                                                    disabled={(totalPages && page >= totalPages) || loading}
                                                >
                                                    Next &raquo;
                                                </button>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default TravelersPage;